<template>
<main>
  <field label="Company Image">
    <div class="control">
      <image-edit title="Select Image" :isRow="true" v-on:change="setImageFile"
      :imageUrl="imageUrl" :imageFile="imageFile"/>
    </div>
  </field>
  <text-field label="Company name *" placeholder="e.g. HireVibes" v-model="name" :error="companyNameError" />
  <text-field label="Company domain *" placeholder="e.g. hirevibes.io" v-model="domain" :error="companyDomainError" />
  <div class="field">
    <label>{{this.$t('profile.companyBio')}} • {{ bioLengthText }}</label>
    <div class="control">
      <textarea :class="getbioClass" :placeholder="this.$t('profile.somethingAboutUrself')"
                v-model="bio">
      </textarea>
      <p class="help is-danger" v-if="bioError">{{bioError}}</p>
    </div>
  </div>
  <hirer-autocomplete :label="companyJobLabel" v-model="companyJobsBoard"></hirer-autocomplete>
</main>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import Field from '@/components/general/field'
import TextField from '@/components/general/text-field'
import ImageEdit from '@/components/general/image-edit'
import TagSelect from '@/components/general/tag-select'
import HirerAutocomplete from '@/components/signup/hirer-autocomplete'

export default {
  components: { Field, TextField, ImageEdit, TagSelect, HirerAutocomplete },
  props: {
    bioError: {
      type: String
    }
  },
  computed: {
    ...mapState('companyForm', {
      formImageFile: 'imageFile',
      formName: 'name',
      formDomain: 'domain',
      formImageUrl: 'imageUrl',
      formCompanyJobBoard: 'companyJobsBoard',
      formBio: 'bio',
      companyNameError: 'companyNameError',
      companyDomainError: 'companyDomainError'
    }),
    companyJobLabel () {
      return this.$t('profile.joinCompany')
    },
    footerText () {
      return this.$t('profile.yourRequest')
    },
    imageUrl () {
      if (this.formImageFile) { return null }
      return this.formImageUrl
    },
    imageFile: {
      get () { return this.formImageFile },
      set (value) { this.setImageFile(value) }
    },
    name: {
      get () { return this.formName },
      set (value) { this.setName(value) }
    },
    domain: {
      get () { return this.formDomain },
      set (value) { this.setDomain(value) }
    },
    companyJobsBoard: {
      get () { return this.formCompanyJobBoard },
      set (value) { this.setCompanyJobBoard(value) }
    },
    bio: {
      get () { return this.formBio },
      set (value) { this.setBio(value) }
    },
    getbioClass () {
      return this.bioError ? 'textarea is-danger' : 'textarea'
    },
    bioLengthText () {
      return this.formBio ? this.formBio.length : 0
    }
  },
  methods: {
    ...mapMutations('companyForm', [
      'setImageFile', 'setName', 'setDomain', 'setCompanyJobBoard', 'setBio'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/companies/company-form.vue